"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const utils_1 = require("data/transactions/utils");
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const styles_1 = require("../styles");
const CheckOptionPicker_1 = __importDefault(require("./CheckOptionPicker"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const CheckField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, txn, wrapClass, editClass, hoverClass, currEditFieldName, enableAutoFocus, staticValue, focusField, }) => {
    var _a;
    const { classes, theme } = useStyles();
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.regItem, wrapClass, editClass, hoverClass, c2RTxnClass)}>
      {SHOW_ALL &&
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
        {editable && !forceStatic && currEditFieldName === 'check' ?
                    <TextField_1.default InputProps={{
                            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
                            disableUnderline: (_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.noUnderline,
                            endAdornment: (<InputAdornment_1.default position="end">
                  <CheckOptionPicker_1.default onSelect={(option) => { var _a; return (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, { target: { value: option } }, 'check'); }}/>
                </InputAdornment_1.default>),
                        }} className={classes.regInput} onFocus={callbacks.handleFocus} placeholder="Check #" autoFocus={enableAutoFocus} value={(txn.check && (txn.check.number || txn.check.memo)) || ''} onChange={(e) => { var _a; return (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, 'check'); }} inputRef={(input) => {
                            focusField.current = input; // eslint-disable-line
                        }}>
          </TextField_1.default> :
                    <QTypography_1.default clickable={!forceStatic ? 'true' : null} thinFont className={classes.regItemCore}>
            {staticValue}
          </QTypography_1.default>}
      </>}
    </styles_1.RegListItem>);
};
exports.default = CheckField;
